import { useLang } from "../context/LanguageContext";
import { useScrollReveal } from "../hooks/useScrollReveal";
import usePageSeo from "../hooks/usePageSeo";
import ProcessTimeline from "../components/ProcessTimeline";
import "./About.css";

const STORY_IMG = "/images/hero/Chi siamo Img uno.jpg";
const WORKSHOP_IMG = "/images/hero/Chi siamo Img due.jpg";
const VALUE_ICONS = ["◇", "◈", "◉", "◎"];

export default function About() {
  useScrollReveal();
  const { t, lang } = useLang();

  usePageSeo({
    lang,
    path: "/about",
    title: lang === "IT"
      ? "Chi siamo | GDM Installations"
      : "About us | GDM Installations",
    description: lang === "IT"
      ? "Conosci GDM Installations: passione per il legno, cura artigianale, attenzione ai dettagli e servizi di qualita per Bari e dintorni."
      : "Meet GDM Installations: passion for wood, artisanal care, attention to detail and quality services for Bari and surrounding areas.",
    keywords: lang === "IT"
      ? "chi siamo GDM Installations, falegnameria edile Bari, artigiani legno Bari, porte interne Bari, rifiniture legno Bari"
      : "about GDM Installations, building carpentry Bari, wood artisans Bari, interior doors Bari, wood finishes Bari",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: lang === "IT" ? "Chi siamo" : "About us",
      url: "https://gdminstallations.it/about",
      description: t.about.story,
      mainEntity: {
        "@type": "LocalBusiness",
        name: "GDM Installations",
        areaServed: "Bari e dintorni",
      },
    },
  });

  return (
    <div className="about-page">
      <div className="page-hero-mini">
        <h1 className="page-hero-title fade-in">{t.about.title}</h1>
        <div className="gold-line" />
        <p className="page-hero-sub fade-in fade-in-delay-1">{t.about.subtitle}</p>
      </div>

      <section className="about-story section">
        <div className="section-inner about-story-inner">
          <div className="about-story-imgs reveal-left">
            <img className="about-img-main" src={STORY_IMG} alt="Workshop" />
            <img className="about-img-secondary" src={WORKSHOP_IMG} alt="Artisan" />
          </div>
          <div className="about-story-text reveal-right fade-in-delay-2">
            <h2 className="about-section-heading">{t.about.subtitle}</h2>
            <div className="gold-line-left" />
            <p>{t.about.story}</p>
          </div>
        </div>
      </section>

      <div className="gold-divider" />

      <section className="about-values section">
        <div className="section-inner">
          <h2 className="section-title reveal-up">{t.about.values_title}</h2>
          <div className="gold-line" />
          <div className="values-grid">
            {t.about.values.map((v, i) => (
              <div key={i} className={`value-card reveal-scale fade-in-delay-${i + 1}`}>
                <div className="value-icon">{VALUE_ICONS[i]}</div>
                <h3 className="value-title">{v.title}</h3>
                <div className="gold-line-left" style={{ width: "30px", margin: "0.8rem 0" }} />
                <p className="value-text">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="gold-divider" />

      <section className="about-stats section">
        <div className="section-inner">
          <div className="stats-grid reveal-up">
            {[
              { num: "6+", label: lang === "IT" ? "Anni di esperienza" : "Years of experience" },
              { num: "79+", label: lang === "IT" ? "Lavori completati" : "Jobs completed" },
              { num: "1", label: lang === "IT" ? "Falegnami artigiani" : "Artisan carpenters" },
              { num: "100%", label: lang === "IT" ? "Materiali certificati" : "Certified materials" },
            ].map((s, i) => (
              <div key={i} className="stat-item">
                <span className="stat-num">{s.num}</span>
                <div className="gold-line-left" style={{ width: "30px", margin: "0.6rem 0" }} />
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="gold-divider" />

      <ProcessTimeline />
    </div>
  );
}
